import { useState, useEffect } from 'react';

interface AnimationSettings {
  duration: number;
  baseDelay: number;
  staggerDelay: number;
  threshold: number;
}

/**
 * Custom hook that provides responsive animation settings based on screen size
 * @returns Animation settings optimized for current screen size
 */
export const useResponsiveAnimation = (): AnimationSettings => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if we're on mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Return different settings based on device type
  return {
    // Shorter durations and delays for mobile
    duration: isMobile ? 0.3 : 0.6,
    baseDelay: isMobile ? 0 : 0.2, // No delay on mobile
    staggerDelay: isMobile ? 0.02 : 0.1,
    threshold: 0.1, // Lower threshold to trigger when just 10% of element is visible
  };
};



